import { useTranslation } from "react-i18next";
import defaultContent from "../../../content/actionReportsWhosNew";

export const WHOS_NEW_TREE_TABS: { months: number; labelKey: "thisMonth" | "lastNumMonths" }[] = [
  { months: 1, labelKey: "thisMonth" },
  { months: 3, labelKey: "lastNumMonths" },
  { months: 6, labelKey: "lastNumMonths" },
  { months: 9, labelKey: "lastNumMonths" },
  { months: 12, labelKey: "lastNumMonths" },
];

/** Translated { months, label } pairs for the tree-view month filter, shared
 *  by the report's own header tabs and the TreeView fullscreen extra controls. */
export const useWhosNewMonthTabs = (): { months: number; label: string }[] => {
  const { t } = useTranslation(["actionReportsWhosNew"]);
  return WHOS_NEW_TREE_TABS.map(({ months, labelKey }) => ({
    months,
    label: t(`treeViewTabs.${labelKey}`, (defaultContent.treeViewTabs as Record<string, string>)[labelKey], {
      numberOfMonths: months,
    }).toString(),
  }));
};

type WhosNewMonthTabButtonsProps = {
  treeTabSelected: number;
  onTabSelect: (months: number) => void;
  tabClassName?: string;
  activeTabClassName?: string;
};

/** The tab `<button>`s themselves, with no wrapping container — used both inside
 *  the report's own scrollable header row and inside TreeView's fullscreen controls,
 *  each of which supplies its own wrapper/scroll behavior and class names. */
export function WhosNewMonthTabButtons({
  treeTabSelected,
  onTabSelect,
  tabClassName = "whos-new-layout__treeViewTab",
  activeTabClassName = "whos-new-layout__treeViewTab--active",
}: WhosNewMonthTabButtonsProps) {
  const tabs = useWhosNewMonthTabs();

  return (
    <>
      {tabs.map(({ months, label }) => (
        <button
          key={months}
          type="button"
          role="tab"
          aria-selected={treeTabSelected === months}
          className={`${tabClassName}${treeTabSelected === months ? ` ${activeTabClassName}` : ""}`}
          onClick={() => onTabSelect(months)}
          data-testid={`tree-view-tab-${months}`}
        >
          {label}
        </button>
      ))}
    </>
  );
}
